// https://github.com/ionic-team/ionic-framework/issues/20515
import { Component, Input, ViewChild, ElementRef, Renderer2, AfterViewChecked, HostBinding } from '@angular/core';

@Component({
  selector: 'mable-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
})
export class InputComponent implements AfterViewChecked {
  @ViewChild('inputLabel', { read: ElementRef, static: false })
  inputLabel: ElementRef;

  @HostBinding('class.no-border') @Input() noBorder = false;

  @HostBinding('attr.icon') @Input() icon = '';

  @Input() label = '';

  @Input() size = 'default';

  @Input() isRequired = false;

  /*
    For inputs not wrapped in form elements.
    <mable-input label="Start date" icon="calendar" [hasError]="true">
      ....
    </mable-input>

    Recommended Usage:
    <form [class.submitted]="isSubmitted">
      <mable-input ....>
      .....
      </mable-input>
    </form>
  */
  @Input() hasError = false;

  classesToRemove = ['sc-ion-label-md-h', 'sc-ion-label-md-s'];

  constructor(private renderer: Renderer2) {}

  ngAfterViewChecked() {
    // Temp fix for stacked input. TODO: Use parts after upgrade to ionic 5
    if (this.inputLabel) {
      this.classesToRemove.forEach((cls) => {
        this.renderer.removeClass(this.inputLabel.nativeElement, cls);
      });
      // this.renderer.addClass(this.inputLabel.nativeElement, 'sanaa');
    }
  }
}
